import { useMutation } from "@tanstack/react-query";
import { ApiSignCustodyAgreement } from "@/api";
import type {
  SignCustodyAgreementRequest,
  SignCustodyAgreementResponse,
} from "@/api/types";

export function useSignCustodyAgreement() {
  return useMutation({
    mutationFn: async (
      data: SignCustodyAgreementRequest
    ): Promise<SignCustodyAgreementResponse> => {
      const res = await ApiSignCustodyAgreement(data);
      console.log("ApiSignCustodyAgreement", res);
      return res.data;
    },
  });
}
